import { h, Host } from '@stencil/core';
// import { Component, Prop, h, Host } from '@stencil/core';
// import i18n from '../../../i18n';
import Chart from 'chart.js/auto';
import { isMobile } from '../../../utils/utils';
// import { isMobile } from '@utils/utils';
// const t = i18n.getTranslation.bind(i18n);
export class ChartListComponent {
  constructor() {
    // componentWillLoad() {
    //   //removes precived age and Skin tone data
    //   this.data = this.data.filter(i => i.title !== 'perceived_age' && i.title !== 'skin_tone');
    // }
    this.handleAttributeClick = (event, innerData, index) => {
      console.log(event, innerData);
      const data = this.chartData[index];
      this.skinAttributeClicked.emit({
        attributeTitle: (data === null || data === void 0 ? void 0 : data.title) || 'NA',
        attributeScore: data.score.map(data => data.score),
        attributeTarget: data.score.map(data => data.targetScore),
      });
      this.currentSlide = index;
      this.updateEventContent.emit({
        targetAchieved: this.updateAttributeContent(),
      });
      this.currentSlide = index;
    };
    this.chartData = [
      {
        title: 'hyperpigmentation',
        score: [
          {
            version: 5,
            score: 94,
            targetScore: 90,
          },
          {
            version: 6,
            score: 94,
            targetScore: 90,
          },
          {
            version: 7,
            score: 93,
            targetScore: 90,
          },
          {
            version: 8,
            score: 93,
            targetScore: 90,
          },
        ],
      },
      {
        title: 'lines',
        score: [
          {
            version: 5,
            score: 98,
            targetScore: 95,
          },
          {
            version: 6,
            score: 98,
            targetScore: 95,
          },
          {
            version: 7,
            score: 86,
            targetScore: 95,
          },
          {
            version: 8,
            score: 86,
            targetScore: 95,
          },
        ],
      },
      {
        title: 'acne',
        score: [
          {
            version: 5,
            score: 100,
            targetScore: 85,
          },
          {
            version: 6,
            score: 100,
            targetScore: 85,
          },
          {
            version: 7,
            score: 93,
            targetScore: 85,
          },
          {
            version: 8,
            score: 93,
            targetScore: 85,
          },
        ],
      },
      {
        title: 'hydration',
        score: [
          {
            version: 5,
            score: 30,
            targetScore: 90,
          },
          {
            version: 6,
            score: 30,
            targetScore: 90,
          },
          {
            version: 7,
            score: 70,
            targetScore: 90,
          },
          {
            version: 8,
            score: 70,
            targetScore: 90,
          },
        ],
      },
      {
        title: 'eye_bags',
        score: [
          {
            version: 5,
            score: 68,
            targetScore: 55,
          },
          {
            version: 6,
            score: 68,
            targetScore: 55,
          },
          {
            version: 7,
            score: 67,
            targetScore: 55,
          },
          {
            version: 8,
            score: 68,
            targetScore: 55,
          },
        ],
      },
    ];
    this.data = undefined;
    this.styles = undefined;
    this.handlers = undefined;
    this.dateList = ['07 Jul', '07 Jul', '10 Jul', '10 Jul'];
    this.attributeTitle = '';
    this.attributeScore = [];
    this.attributeTarget = [];
    this.chart = undefined;
    this.currentSlide = 0;
    this.prevSlide = -1;
  }
  skinAttributeClickedEventHandler(event) {
    this.attributeTitle = event.detail['attributeTitle'];
    this.attributeScore = event.detail['attributeScore'];
    this.attributeTarget = event.detail['attributeTarget'];
    this.updateAttributeTitle(this.chart);
  }
  updateAttributeTitle(chart) {
    chart.data.datasets[0].label = this.attributeTitle;
    chart.data.datasets[0].data = this.attributeScore;
    chart.data.datasets[0].targetData = this.attributeTarget;
    chart.data.datasets[1].data = this.attributeTarget;
    chart.update();
  }
  updateAttributeContent() {
    const [latestScore] = this.attributeScore.splice(-1);
    let targetScore = this.attributeTarget[0];
    return latestScore >= targetScore;
  }
  slidePrev() {
    this.currentSlide = (this.currentSlide - 1) % this.chartData.length;
    this.renderChartOnclick();
  }
  renderChartOnclick() {
    this.attributeContainerRef.getElementsByTagName('button').item(this.currentSlide).click();
    this.attributeContainerRef.getElementsByTagName('button').item(this.currentSlide).focus();
    const data = this.chartData[this.currentSlide];
    this.skinAttributeClicked.emit({
      attributeTitle: data === null || data === void 0 ? void 0 : data.title,
      attributeScore: data.score.map(data => data.score),
      attributeTarget: data.score.map(data => data.targetScore),
    });
    this.updateEventContent.emit({
      targetAchieved: this.updateAttributeContent(),
    });
  }
  slideNext() {
    this.currentSlide = (this.currentSlide + 1) % this.chartData.length;
    this.renderChartOnclick();
  }
  async componentWillLoad() {
    var _a, _b;
    if ((this === null || this === void 0 ? void 0 : this.handlers) && ((_a = this === null || this === void 0 ? void 0 : this.handlers) === null || _a === void 0 ? void 0 : _a.handleChartListWillLoad)) {
      const { chartData, dateList } = await ((_b = this === null || this === void 0 ? void 0 : this.handlers) === null || _b === void 0 ? void 0 : _b.handleChartListWillLoad());
      this.chartData = chartData;
      this.dateList = dateList;
    }
  }
  componentDidLoad() {
    var _a, _b;
    console.log('[line-chart.prop.data]', this.chartData);
    console.log('[line-chart.prop.dateList]', this.dateList);
    console.log('...loading', this.currentSlide, this.prevSlide, this.currentSlide !== this.prevSlide);
    if (this.currentSlide !== this.prevSlide) {
      const chartData1 = {
        labels: this.dateList,
        datasets: [
          {
            label: this.attributeTitle,
            data: this.attributeScore,
            targetData: this.attributeTarget,
            backgroundColor: '#9EC9C1',
            borderColor: '#222',
            pointStyle: 'circle',
            pointRadius: 7,
            pointHoverRadius: 10,
            tension: 0.2,
          },
          {
            label: 'Target',
            data: this.attributeTarget,
            borderColor: '#FF7272',
            pointRadius: 0,
            borderWidth: 1,
          },
        ],
      };
      console.log('...loading1');
      this.chart = new Chart(this.containerRef, {
        type: 'line',
        data: chartData1,
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: {
              grid: {
                display: false,
                borderColor: '#000',
              },
            },
            yAxes: {
              grid: {
                borderColor: '#000',
              },
              min: 0,
              max: 120,
              ticks: {
                stepSize: 20,
                autoSkip: false,
                callback(value) {
                  return value !== 120 ? this.getLabelForValue(+value) : '';
                },
              },
            },
          },
          layout: {
            padding: {
              left: 5,
              right: 5,
              bottom: 10,
            },
          },
          plugins: {
            legend: {
              display: false,
            },
            title: {
              display: true,
              text: 'Progress',
              align: 'start',
              padding: { bottom: 30 },
            },
            tooltip: {
              displayColors: false,
              callbacks: {
                label(context) {
                  let attribute = context.dataset.label;
                  let currentScore = `Current Score: ${context.parsed.y}`;
                  let targetScore = `Target Score: ${context.dataset['targetData'][0]}`;
                  return [attribute, currentScore, targetScore];
                },
              },
            },
          },
        },
      });
      if (this.chartData && ((_a = this === null || this === void 0 ? void 0 : this.chartData[0]) === null || _a === void 0 ? void 0 : _a.title)) {
        this.attributeContainerRef.getElementsByTagName('button').item(0).click();
        this.attributeContainerRef.getElementsByTagName('button').item(0).focus();
        this.skinAttributeClicked.emit({
          attributeTitle: (_b = this === null || this === void 0 ? void 0 : this.chartData[0]) === null || _b === void 0 ? void 0 : _b.title,
          attributeScore: this.chartData[0].score.map(data => data.score),
          attributeTarget: this.chartData[0].score.map(data => data.targetScore),
        });
        this.updateEventContent.emit({
          targetAchieved: this.updateAttributeContent(),
        });
        // this.attributeContainerRef.getElementsByTagName('button').item(0).focus();
      }
      this.prevSlide = this.currentSlide;
    }
  }
  render() {
    // console.log('line-chart-prop-data', this.data);
    return (h(Host, null, this.styles && h("style", null, this.styles), h("div", { class: "chart-list-wrapper" }, this.data &&
      this.data.map((element) => {
        var _a, _b, _c, _d;
        if (element.name === 'aiba-header-container') {
          return (h("div", { class: "chart-header-container", ref: el => (this.attributeContainerRef = el) }, this.chartData &&
            this.chartData.map((item, index) => {
              return h("aiba-button", { value: (item === null || item === void 0 ? void 0 : item.title) || 'NA', handleClick: e => this.handleAttributeClick(e, item, index) });
            })));
        }
        if (element.name === 'navigation') {
          return (h("div", { class: "navigation" }, (_b = (_a = element.data) === null || _a === void 0 ? void 0 : _a.elements) === null || _b === void 0 ? void 0 : _b.map((innerElement) => {
            if (innerElement.name === 'aiba-button' && innerElement['data'] && innerElement['data']['_id'] === 'aiba-chart-list-prev-button' && isMobile()) {
              return h("aiba-button", Object.assign({}, innerElement['data'], { handleClick: () => this.slidePrev(), disabled: this.currentSlide === 0 }));
            }
            if (innerElement.name === 'aiba-button' && innerElement['data'] && innerElement['data']['_id'] === 'aiba-chart-list-next-button' && isMobile()) {
              return (h("aiba-button", Object.assign({}, innerElement['data'], { handleClick: () => this.slideNext(), disabled: this.currentSlide === this.chartData.length - 1 })));
            }
          })));
        }
        if (element.name === 'aiba-chart-list') {
          return (h("div", { class: "chart-container" }, h("canvas", { ref: el => (this.containerRef = el) })));
        }
        if (element.name === 'aiba-chart-footer') {
          {
            return (element.data &&
              ((_d = (_c = element.data) === null || _c === void 0 ? void 0 : _c.elements) === null || _d === void 0 ? void 0 : _d.map((innerElement) => {
                if (innerElement.name === 'aiba-legend') {
                  return (h("div", { class: "legend-container" }, h("aiba-legend", Object.assign({}, innerElement, { data: innerElement['data'] }))));
                }
              })));
          }
        }
      }))));
  }
  static get is() { return "aiba-chart-list"; }
  static get originalStyleUrls() {
    return {
      "$": ["./aiba-chart-list.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-chart-list.css"]
    };
  }
  static get properties() {
    return {
      "chartData": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "{ title: string; score: { version: number; score: number; targetScore: number; }[]; }[]",
          "resolved": "{ title: string; score: { version: number; score: number; targetScore: number; }[]; }[]",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "defaultValue": "[\n    {\n      title: 'hyperpigmentation',\n      score: [\n        {\n          version: 5,\n          score: 94,\n          targetScore: 90,\n        },\n        {\n          version: 6,\n          score: 94,\n          targetScore: 90,\n        },\n        {\n          version: 7,\n          score: 93,\n          targetScore: 90,\n        },\n        {\n          version: 8,\n          score: 93,\n          targetScore: 90,\n        },\n      ],\n    },\n    {\n      title: 'lines',\n      score: [\n        {\n          version: 5,\n          score: 98,\n          targetScore: 95,\n        },\n        {\n          version: 6,\n          score: 98,\n          targetScore: 95,\n        },\n        {\n          version: 7,\n          score: 86,\n          targetScore: 95,\n        },\n        {\n          version: 8,\n          score: 86,\n          targetScore: 95,\n        },\n      ],\n    },\n    {\n      title: 'acne',\n      score: [\n        {\n          version: 5,\n          score: 100,\n          targetScore: 85,\n        },\n        {\n          version: 6,\n          score: 100,\n          targetScore: 85,\n        },\n        {\n          version: 7,\n          score: 93,\n          targetScore: 85,\n        },\n        {\n          version: 8,\n          score: 93,\n          targetScore: 85,\n        },\n      ],\n    },\n    {\n      title: 'hydration',\n      score: [\n        {\n          version: 5,\n          score: 30,\n          targetScore: 90,\n        },\n        {\n          version: 6,\n          score: 30,\n          targetScore: 90,\n        },\n        {\n          version: 7,\n          score: 70,\n          targetScore: 90,\n        },\n        {\n          version: 8,\n          score: 70,\n          targetScore: 90,\n        },\n      ],\n    },\n    {\n      title: 'eye_bags',\n      score: [\n        {\n          version: 5,\n          score: 68,\n          targetScore: 55,\n        },\n        {\n          version: 6,\n          score: 68,\n          targetScore: 55,\n        },\n        {\n          version: 7,\n          score: 67,\n          targetScore: 55,\n        },\n        {\n          version: 8,\n          score: 68,\n          targetScore: 55,\n        },\n      ],\n    },\n  ]"
      },
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "styles": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      },
      "dateList": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "string[]",
          "resolved": "string[]",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "defaultValue": "['07 Jul', '07 Jul', '10 Jul', '10 Jul']"
      }
    };
  }
  static get states() {
    return {
      "attributeTitle": {},
      "attributeScore": {},
      "attributeTarget": {},
      "chart": {},
      "currentSlide": {},
      "prevSlide": {}
    };
  }
  static get events() {
    return [{
        "method": "skinAttributeClicked",
        "name": "skinAttributeClicked",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        }
      }, {
        "method": "updateEventContent",
        "name": "updateEventContent",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        }
      }];
  }
  static get listeners() {
    return [{
        "name": "skinAttributeClicked",
        "method": "skinAttributeClickedEventHandler",
        "target": undefined,
        "capture": false,
        "passive": false
      }];
  }
}
//# sourceMappingURL=aiba-chart-list.js.map
